import { useLocation, useNavigate } from "react-router-dom";
import "./DeletePopup.css";

const DeletePopup = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { id, name } = location.state || {};

  const handleDelete = () => {
    const products = JSON.parse(localStorage.getItem("products")) || [];

    const updatedProducts = products.filter(
      (item) => String(item.id) !== String(id),
    );

    localStorage.setItem("products", JSON.stringify(updatedProducts));

    navigate("/products");
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal">
        <div className="close-btn" onClick={handleCancel}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M15 5L5 15"
              stroke="#3E3E3E"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5 5L15 15"
              stroke="#3E3E3E"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <div className="delete-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="#EA3323"
          >
            <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z" />
          </svg>
        </div>

        <h2>Delete Product?</h2>

        <p>
          Are you sure you want to delete <strong>{name}</strong>?
          <br />
          This action cannot be undone.
        </p>

        <div className="delete-actions">
          <button className="cancel-btn" onClick={handleCancel}>
            Cancel
          </button>

          <button className="confirm-delete-btn" onClick={handleDelete}>
            Confirm Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopup;
